import {AnalysisGraphQL} from 'analysis-tool/AnalysisTypes';
import {assert} from 'Asserts';
import {PipelineStepStatusCode, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStep} from 'pipelines/PipelineTypes';

import {AnalysisLayoutStatus, AnalysisLayoutStatusInfo} from './AnalysisAdapterTypes';
import {resolveReference} from './AnalysisAdapterUtils';

export default function getAnalysisLayoutStatusInfo(
  analysis: AnalysisGraphQL,
  layoutStep: PipelineStep<PipelineStepType.LAYOUT, 0>
): AnalysisLayoutStatusInfo {
  if (layoutStep.statusCode === PipelineStepStatusCode.SUCCEEDED) {
    return {status: AnalysisLayoutStatus.READY};
  }

  if (layoutStep.config == null) {
    return {
      status: AnalysisLayoutStatus.FAILED,
      message: 'We ran into an issue displaying this layout.',
      reason: 'Please contact Benchling Support for help.',
    };
  }

  for (const statusDependency of layoutStep.config.statusDependencies ?? []) {
    for (const parentReference of statusDependency?.inputReferences ?? []) {
      const parentStep = resolveReference(parentReference, layoutStep, analysis);
      const parentStatus = parentStep.statusCode;

      if (parentStatus === PipelineStepStatusCode.FAILED) {
        return {
          status: AnalysisLayoutStatus.FAILED,
          message: statusDependency.failureMessage,
          reason: parentStep.statusMessage!,
        };
      } else if (
        parentStatus === PipelineStepStatusCode.BLOCKED ||
        parentStatus === PipelineStepStatusCode.WAITING ||
        parentStatus === PipelineStepStatusCode.RUNNING ||
        parentStatus === PipelineStepStatusCode.AI_PROPOSED
      ) {
        return {status: AnalysisLayoutStatus.RUNNING, message: statusDependency.runningMessage};
      } else {
        assert(parentStatus === PipelineStepStatusCode.SUCCEEDED, `Unknown status code: ${parentStatus}`);
      }
    }
  }

  return {status: AnalysisLayoutStatus.READY};
}
